/* eslint-disable indent */
/* eslint-disable id-length */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-len */
import * as React from 'react';
import './index.scss';
import { Provider } from 'react-redux';
import store, { useAppSelector } from '../../toolkit';

const isProd = process.env.TIGER_BUILD_ENV === 'pre';
if (!isProd) {
  // new VConsole();
}

const Over = () => (
  <div className="over">
    <div className="btn"></div>
    <div className="over-intro">
      本期活动已结束
      <br />
      去看看其他活动吧
    </div>
  </div>
);

export default (): React.ReactNode => (
  <Provider store={store}>
    <Over />
  </Provider>
);
